import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { ActiontrackerService } from '../../../actiontracker/services/actiontracker.service';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { ObservationService } from '../../../observation/services/observation.service';
import { IndependentPermissions } from '../../../shared/models/IndependentPermissions.model';
import { UserPermissionParameters } from '../../../shared/models/user.model';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { RiskDashboard } from '../../model/riskDashboard';
import { RiskDashboardFilter } from '../../model/riskDashboardFilter';
import { RiskConstantsService } from './../../services/risk-constants.service';
import { RiskService } from './../../services/risk.service';
import { RaiseRiskAllMaster } from "./../../model/raiseRiskAllMaster";

import {AssetsRisk, EnvironmentRisk, NPTRisk, PearDetails, PeopleRisk, RaiseRisk, ReputationRisk, RiskRequest} from "./../../model/riskRequest.model";
import { ConstantsService } from "../../../shared/services/constants.service";
import { ActivatedRoute, Router } from "@angular/router";
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
type AOA = string[][];
import { coerceNumberProperty } from "@angular/cdk/coercion";
import * as fileSaver from 'file-saver';
import { isTemplateMiddle } from 'typescript';
import { SpecificationData } from 'src/app/shared/components/category/category.component';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'ara-my-risk-dashboard',
  templateUrl: './my-risk-dashboard.component.html',
  styleUrls: ['./my-risk-dashboard.component.css']
})
export class MyRiskDashboardComponent implements OnInit {
  @ViewChild('cm') contextMenu: ContextMenu;
  riskDashboardFilter: RiskDashboardFilter;
  riskData: RiskDashboard[] = [];
  actionData = [];
  pendingAction = [];
  closedAction = [];
  noRecordsMsg: string;
  selectedPear = [];
  selectedRiskIdentified = [];
  isSelectedPearNull: boolean = true;
  isSelectedRiskIdentifiedNull: boolean = true;
  showPagination: boolean = true;
  loggedInUserJSON: any;
  riskStatus: number[] = [];
  pageSize: number = 1;
  pearMaster = [];
  riskIdentified = [];
  totalRow = 50;
  rowCount: number;
  routesFlag: { routeName: string, routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string, routeURL: string; isClickable: boolean; }[];
  max: number = 0;
  pear: string = '';
  columnList: any;
  jsonString: string;
  isExportChecked: boolean;
  itemPerPage: number = 50;
  exportData: RiskDashboard[];
  riskRequestId: number;
  searchText: string = '';
  RiskManagementToolId : number = 0;
  HEMPRiskManagementToolId: number = ConstantsService.RiskManagementTool.HEMP;
  searchModified: boolean = false;
  riskSources: any[] = [];
  selectedRiskSources: number[] = [];
  riskAddedFromDate: Date = null;
  riskAddedToDate: Date = null;
  hideFilter: boolean = true;
  hideSort: boolean = true;
  riskPermission: IndependentPermissions;
  userPermissions: UserPermissionParameters;
  disableRisk: boolean;
  checked: boolean;
  currentDate = new Date();
  selectedRisk: any;
  contextItems: MenuItem[] = [];
  row: HTMLElement;
  window = window;
  isRisksChecked: boolean = true;
  riskSourceIdsDetails: any = [];
  currentSourceRowCount: number;
  selectedUnit: any[];
  unitList: any[];
  status: any[];
  disableExport: boolean = false;
  raiseRiskAllMaster = new RaiseRiskAllMaster();
  raiseRisks: RaiseRisk[] =[];
  permissions: any = [];
  ToolName : string = '';
  riskToolId : number = 0;
  RiskExportId : number = 0;
  RiskExportToolId : number = 0;
  RedirectFromDashboard : number = 0;
  PotentialPeopleRisk = new PeopleRisk();
  PotentialAssetsRisk = new AssetsRisk();
  PotentialEnvironmentRisk = new EnvironmentRisk();
  PotentialReputationRisk = new ReputationRisk();
  PotentialNPTRisk = new NPTRisk();
  ResidualPeopleRisk = new PeopleRisk();
  ResidualAssetsRisk = new AssetsRisk();
  ResidualEnvironmentRisk = new EnvironmentRisk();
  ResidualReputationRisk = new ReputationRisk();
  ResidualNPTRisk = new NPTRisk();
  
  RiskassessmentPeople = new PeopleRisk();
  RiskassessmentAssets = new AssetsRisk();
  RiskassessmentEnvironment = new EnvironmentRisk();
  RiskassessmentReputation = new ReputationRisk();
  RiskassessmentNPT = new NPTRisk();
  ResidualP:string = '';
  ResidualE:string = '';
  ResidualA:string = '';
  ResidualR:string = '';
  ResidualN:string = '';
  CurrentP:string = '';
  CurrentE:string = '';
  CurrentA:string = '';
  CurrentR:string = '';
  CurrentN:string = '';
  specificationDetailsData: SpecificationData;
  lifeSavingCheckedValueData: any[] = [];
  constructor(private baseService: BaseService,
    private router: Router,
    private riskService: RiskService,
    private commonService: CommonService,
    private notificationsService: NotificationsService,
    private translate: TranslateService,
    private masterscreenService: MasterscreenService,
    private observationService: ObservationService,
    private actionTrackerService: ActiontrackerService,private http: HttpClient,
    private route: ActivatedRoute) {
    this.riskPermission = new IndependentPermissions();
    this.userPermissions = new UserPermissionParameters();
    this.selectedUnit = [];
   
  }

  ngOnInit() {
    this.baseService.showRootLoader = true;
    this.permissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    this.contextItems = [
      {
        label: 'Open In New Tab',
        icon: 'fa-external-link-square',
        command: e => this.openTask()
      }];
    // Set routeURL and route name for Risk
    const routes = JSON.stringify(RiskConstantsService.RiskNavigation.Routes);
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = RiskConstantsService.RiskNavigation.ReportRoutes;
    this.route.params.subscribe(params => {
      this.RedirectFromDashboard = isNaN(params["D"])? 0 :coerceNumberProperty(params["D"]);
    });
    this.pearMaster = RiskConstantsService.PearForDashboard;
    this.pearMaster.forEach((pear) => {
      pear.Checked = true;
    }
    );
    this.riskIdentified = RiskConstantsService.RiskIdentified;
    this.riskIdentified.forEach((riskIdentify) => {
      riskIdentify.Check = true;
    }
    );
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.riskDashboardFilter = new RiskDashboardFilter();
    this.commonService.getUserIndependentPermissions(this.loggedInUserJSON.UserId);
    this.permissions = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    this.actionTrackerService.getProcess(this.callbackMethodForgetProcess.bind(this));
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
    this.getAllMasterForRisk();
  }
  callbackMethodForgetProcess(response) {
    if (response.Error != null) {
      console.error(response.Error);
    }
    if (response.Success) {
      response.Result.forEach(process => {
        if (process.ProcessName === 'Risk') {
          this.getStatusForRisk(process.ProcessId);
        }
      });
    }
  }
  getRiskForDashboard() {
    if(this.RedirectFromDashboard == 1)
    {
      this.reset();
      const filter = JSON.parse(this.baseService.getFilterData('dashboardFilter'));
      if(filter)
      {
        this.riskAddedFromDate = new Date(filter.Model.FromDateForOverview);
        this.riskAddedToDate = new Date(filter.Model.ToDateForOverview);
      }
    }
    this.baseService.showRootLoader = true;
    if (this.selectedPear.length === 0) {
      this.pearMaster.forEach((pear) => {
        this.selectedPear.push(pear.Id);
      }
      );
      this.isSelectedPearNull = false;
      this.riskDashboardFilter.StartRowIndex = 0;
      this.riskDashboardFilter.TotalRow = this.totalRow;
    }
    this.riskDashboardFilter.TotalRow = this.itemPerPage;
    if (this.selectedRiskIdentified.length === 0) {
      this.riskIdentified.forEach(riskIdentify => {
        riskIdentify.Value.forEach(value => {
          this.selectedRiskIdentified.push(value);
        });
      });
      this.isSelectedRiskIdentifiedNull = false;
    }
    if (!this.selectedUnit.length) {
      this.unitList.forEach(element => {
        this.selectedUnit.push(element.value);
      });
    }
    this.riskDashboardFilter.Units = this.selectedUnit;
    if (!this.rowCount) {
      this.rowCount = this.totalRow * 2;
    }
    this.riskDashboardFilter.OrderdByColoumName = RiskConstantsService.OrderByColoumnName.CreatedDate;
    this.riskDashboardFilter.OrderdBy = RiskConstantsService.OrderBy.DESC;
    this.riskDashboardFilter.CurrentPage = this.pageSize;
    this.riskDashboardFilter.EmployeeId = this.loggedInUserJSON.UserId;
    this.riskDashboardFilter.Status = this.riskStatus;
    this.riskDashboardFilter.RiskIdentified = this.selectedRiskIdentified;
    this.riskDashboardFilter.PotentialRiskPears = this.selectedPear;
    this.riskDashboardFilter.SearchText = this.searchText;
    this.riskDashboardFilter.RiskAddedFromDate = this.riskAddedFromDate !== null ? new Date(this.riskAddedFromDate.setHours(0, 0, 0, 0)) : this.riskAddedFromDate;
    this.riskDashboardFilter.RiskAddedToDate = this.riskAddedToDate !== null ? new Date(this.riskAddedToDate.setHours(23, 59, 59, 0)) : this.riskAddedToDate;
    this.riskDashboardFilter.RiskSources = this.selectedRiskSources;
    this.riskDashboardFilter.UnitId = 0;
    this.riskDashboardFilter.ToolId = this.RiskManagementToolId;
    this.riskDashboardFilter.SelectAll = this.isRisksChecked;
    const filter = JSON.parse(this.baseService.getFilterData('riskFilter'));
    if (!this.searchModified && filter) {
      this.riskDashboardFilter = filter;
      this.riskDashboardFilter.ToolId = this.RiskManagementToolId;
      this.riskAddedFromDate = filter.RiskAddedFromDate === null ? filter.RiskAddedFromDate : new Date(filter.RiskAddedFromDate);;
      this.riskAddedToDate = filter.RiskAddedToDate === null ? filter.RiskAddedToDate : new Date(filter.RiskAddedToDate);;
      this.selectedRiskSources = filter.RiskSources;
      this.selectedPear = filter.PotentialRiskPears;
      this.selectedRiskIdentified = filter.RiskIdentified;
      this.riskStatus = filter.Status;
      this.searchText = filter.SearchText;
      this.selectedUnit = filter.Units;
      this.isRisksChecked = filter.SelectAll;
      if (!this.riskService.getAllRiskIds()) {
        this.isRisksChecked = true;
        this.riskDashboardFilter.SelectAll = true;
      }
      this.pageSize = parseInt(filter.CurrentPage);
      if (this.pageSize === 1) {
        this.riskDashboardFilter.StartRowIndex = 0;
      } else {
        this.riskDashboardFilter.StartRowIndex = ((this.pageSize * this.totalRow) - this.totalRow);
        this.rowCount = ((this.pageSize + 1) * this.totalRow);
      }
    } else {
      this.baseService.setFilterData('riskFilter', JSON.stringify(this.riskDashboardFilter));
    }
    const apiRequest = {
      Model: this.riskDashboardFilter
    };
    this.riskService.getRiskForDashboard(apiRequest, this.callbackMethodForgetRiskForDashboard.bind(this));
  }
  callbackMethodForgetRiskForDashboard(response) {
    this.showPagination = true;
    this.riskData = response.Result;
    if(response.Result.length > 0)
    {
    //  for (var i = response.Result.length - 1; i >= 0; i--) 
    //  {
    //    if (this.loggedInUserJSON.UserTypeId==2 && response.Result[i].CreatedBy !== this.loggedInUserJSON.UserId) 
    //    {
    //      response.Result.splice(i, 1);
    //    }
    //  }
   //  response.Result.forEach((element,index) => {
   //    if(element.Status ==='Draft' && element.CreatedById !== this.loggedInUserJSON.UserId)  
   //    {
   //      response.Result.splice(index,1);
   //    }
   //  });
    }
    // if (response.Result.length > 0) {
    //   this.riskData.forEach((risk) => {
    //     this.max = 0;
    //     risk.PotentialPEARList.forEach(pearDetails => {
    //       if (this.max < (pearDetails.RiskSeverity * this.getIntValue(pearDetails.RiskLikelihood))) {
    //         this.max = (pearDetails.RiskSeverity * this.getIntValue(pearDetails.RiskLikelihood));
    //         this.pear = pearDetails.RiskPear.toString();
    //       }
    //     });
    //     risk.PotentialPEARList.forEach(element => {
    //       if (element.RiskPear === this.pear) {
    //         risk.potentialPEARColor = this.riskService.getRiskColorClass(element.RiskSeverity.toString(), element.RiskLikelihood);
    //         return;
    //       }
    //     });
    //     risk.ResidualPEARList.forEach(element => {
    //       if (element.RiskPear === this.pear) {
    //         risk.residualPEARColor = this.riskService.getRiskColorClass(element.RiskSeverity.toString(), element.RiskLikelihood);
    //         return;
    //       }
    //     });
    //     risk.RiskAssessmentPEARList.forEach(element => {
    //       if (element.RiskPear === this.pear) {
    //         risk.assessmentPEARColor = this.riskService.getRiskColorClass(element.RiskSeverity.toString(), element.RiskLikelihood);
    //         return;
    //       }
    //     });
    //   });
    // }
    if (this.isExportChecked === true) {
      this.exportData = response.Result;
      this.columnList = [
        { key: "DisplayId", value: "Risk ID" },
        { key: "HazardIdentified", value: "Hazard Identified" },
        { key: "Source", value: "Source" },
        { key: "CreatedDate", value: "Risk Added Date" },
        { key: "potentialPEARColor", value: "Potential Risk" },
        { key: "residualPEARColor", value: "Residual Risk" },
        { key: "assessmentPEARColor", value: "Current Risk" },
        { key: "UnitName", value: "Unit" }
      ];

      const parsedResponse = FileUtility.convertToCSV(this.exportData, this.columnList);
      FileUtility.downloadCSV(parsedResponse, 'RiskReport.csv');
      this.isExportChecked = false;
    }
    if (!response.Result || response.Result.length < this.totalRow) {
      this.rowCount = this.rowCount - this.totalRow;
    }
    if (response.Success) {
      if (response.Result.length === 0) {
        this.showPagination = false;
        this.noRecordsMsg = 'No records found!';
      }
    }
    if (this.riskDashboardFilter.SelectAll && !this.searchModified) {
      this.selectAllRisks(this.riskDashboardFilter.SelectAll);
    } else if (this.searchModified) {
      this.riskDashboardFilter.SelectAll = true;
      this.riskService.setAllRiskIds([]);
      this.selectAllRisks(this.riskDashboardFilter.SelectAll);
    } else {
      if (this.riskService.getAllRiskIds()) {
        this.riskData.forEach(element => {
          this.riskService.getAllRiskIds().forEach(stored => {
            if (element.RiskRequestId === (stored != null ? stored.RiskRequestId : stored) ) {
              element.Checked = true;
            }
          });
        });
      }
    }
    //this.getRiskData();
    this.baseService.showRootLoader = false;
  }
  getIntValue(severity) {
    switch (severity) {
      case 'A':
        return 1;
      case 'B':
        return 2;
      case 'C':
        return 3;
      case 'D':
        return 4;
      case 'E':
        return 5;
    }
  }
  selectPear(checked, pear) {
    if (this.isSelectedPearNull === false) {
      this.selectedPear = [];
    }
    if (checked === true) {
      this.selectedPear.push(pear.Id);
      pear.Checked = true;
      this.isSelectedPearNull = true;
    } else {
      const index = this.selectedPear.indexOf(pear.Id);
      this.selectedPear.splice(index, 1);
      pear.Checked = false;
    }
  }

  selectRiskIdentified(checked, riskIdentified) {
    if (this.isSelectedRiskIdentifiedNull === false) {
      this.selectedRiskIdentified = [];
    }
    if (checked === true) {
      this.riskIdentified.forEach(riskIdentify => {
        if (riskIdentified.Id === riskIdentify.Id) {
          riskIdentify.Value.forEach(value => {
            this.selectedRiskIdentified.push(value);
          });
        }
        riskIdentify.Checked = true;
      });
      this.isSelectedRiskIdentifiedNull = true;
    } else {
      this.riskIdentified.forEach(riskIdentify => {
        if (riskIdentified.Id === riskIdentify.Id) {
          riskIdentify.Value.forEach(value => {
            const index = this.selectedRiskIdentified.indexOf(value);
            this.selectedRiskIdentified.splice(index, 1);
          });
        }
        riskIdentify.Checked = false;
      });
    }
  }

  descRiskAddedOn() {
    this.riskDashboardFilter.OrderdByColoumName = RiskConstantsService.OrderByColoumnName.CreatedDate;
    this.riskDashboardFilter.OrderdBy = RiskConstantsService.OrderBy.DESC;
    this.searchModified = true;
    this.getRiskForDashboard();
  }

  ascRiskAddedOn() {
    this.riskDashboardFilter.OrderdByColoumName = RiskConstantsService.OrderByColoumnName.CreatedDate;
    this.riskDashboardFilter.OrderdBy = RiskConstantsService.OrderBy.ASC;
    this.searchModified = true;
    this.getRiskForDashboard();
  }

  ascRiskRating() {
    this.riskDashboardFilter.OrderdByColoumName = RiskConstantsService.OrderByColoumnName.RiskRating;
    this.riskDashboardFilter.OrderdBy = RiskConstantsService.OrderBy.ASC;
    this.getRiskForDashboard();
  }

  descRiskRating() {
    this.riskDashboardFilter.OrderdByColoumName = RiskConstantsService.OrderByColoumnName.RiskRating;
    this.riskDashboardFilter.OrderdBy = RiskConstantsService.OrderBy.DESC;
    this.getRiskForDashboard();
  }

  doneFilter() {
    this.rowCount = this.totalRow * 2;
    this.searchModified = true;
    this.getRiskForDashboard();
    this.riskService.setAllRiskIds([]);
    this.hideFilter = false;
  }

  reset()
  {
    this.pearMaster.forEach((pear) => {
      pear.Checked = true;
    }
    );
    this.riskIdentified.forEach((riskIdentify) => {
      riskIdentify.Check = true;
    }
    );
    this.selectedPear = [];
    this.selectedRiskIdentified = [];
    this.rowCount = null;
    //this.selectedRiskSources = [];
    this.riskDashboardFilter = new RiskDashboardFilter();
    this.riskAddedFromDate = null;
    this.riskAddedToDate = null;
    this.riskDashboardFilter.OrderdByColoumName = RiskConstantsService.OrderByColoumnName.CreatedDate;
    this.riskDashboardFilter.OrderdBy = RiskConstantsService.OrderBy.DESC;
    this.selectedUnit = [];
    this.riskStatus = [];
    this.status.forEach(status => {
      this.riskStatus.push(status.value);
    })
    // this.riskDashboardFilter.RiskAddedFromDate = null;
    // this.riskDashboardFilter.RiskAddedToDate = null;
    this.searchModified = true;
    this.RedirectFromDashboard = 0;
    this.riskService.setAllRiskIds([]);
  }

  resetValue() {
    this.reset();
    this.selectedRiskSources = [];
    this.getAllMasterForRaiseRisk();
    this.onClickedOutside();
  }

  getServerData(event) {
    if (event === 1) {
      this.riskDashboardFilter.StartRowIndex = 0;
    } else {
      this.riskDashboardFilter.StartRowIndex = ((event * this.totalRow) - this.totalRow);
      this.rowCount = ((event + 1) * this.totalRow);
    }
    this.pageSize = event;
    this.searchModified = true;
    this.getRiskForDashboard();
  }

  showAction(riskRequestId) {
    const apiRequest = {
      Model: {
        'RiskRequestId': riskRequestId
      }
    };
    // Get all observation type data
    this.riskService.getAllActionByRiskRequestId(apiRequest, this.callbackMethodForGetAllActionByRiskRequestId.bind(this));
  }

  callbackMethodForGetAllActionByRiskRequestId(response) {
    this.closedAction = [];
    this.pendingAction = [];
    this.actionData = response.Result;
    this.actionData.forEach(action => {
      if (action.Status.StatusName === RiskConstantsService.Status.Closed) {
        this.closedAction.push(action);
      } else {
        this.pendingAction.push(action);
      }
    });

  }
  getStatusForRisk(processId) {
    const apiRequest = {
      Model: {
        ProcessId: processId
      }
    };
    this.actionTrackerService.getStatusByProcessId(apiRequest, this.callbackMethodForgetStatus.bind(this));
  }
  callbackMethodForgetStatus(response) {
    if (response.Success) {
      this.status = [];
      this.riskStatus = [];
      response.Result.forEach(element => {
        this.status.push({
          label: element.StatusName,
          value: element.StatusId,
          checked: true
        });
        this.riskStatus.push(element.StatusId);
      });
    }
    this.getUnits();
  }
  getColorName(color) {
    switch (color) {
      case 'riskColorBlue':
        return 'Low';
      case 'riskColorYellow':
        return 'Medium';
      case 'riskColorRed':
        return 'High';
      default:
        return "NA";
    }
  }

  Download(riskRequestId,ToolName)
  {
    if(ToolName.trim() == "MOC"){this.riskToolId = ConstantsService.RiskManagementTool.MOC;}
    else if(ToolName.trim() == "JSA"){this.riskToolId = ConstantsService.RiskManagementTool.JSA;}
    else if(ToolName.trim() == "HEMP"){this.riskToolId = ConstantsService.RiskManagementTool.HEMP;}
    else if(ToolName.trim() == "HAZOP"){this.riskToolId = ConstantsService.RiskManagementTool.HAZOP;}
    else if(ToolName.trim() == "HAZID"){this.riskToolId = ConstantsService.RiskManagementTool.HAZID;}
    
    if(this.riskToolId == ConstantsService.RiskManagementTool.HEMP
        // || this.riskToolId == ConstantsService.RiskManagementTool.HAZID
       || this.riskToolId == ConstantsService.RiskManagementTool.JSA
        // || this.riskToolId == ConstantsService.RiskManagementTool.HAZOP
      )
    {
      this.ExportRiskToExcel(riskRequestId,this.riskToolId);
    }
    else
    {
      this.downloadPDF(riskRequestId);
    }
  }

  //Export To Excel
  ExportRiskToExcel(riskRequestId,riskToolId)
  {     
     let fileName : string = '' ;
     this.RiskExportId = riskRequestId;
     this.RiskExportToolId = riskToolId;
     if(this.RiskExportToolId == ConstantsService.RiskManagementTool.HEMP)
     {
      fileName = "HEMP-Overview";
     }
     else if(this.RiskExportToolId == ConstantsService.RiskManagementTool.JSA)
     {
      fileName = "JSA-Overview";
     }
     if(this.RiskExportToolId == ConstantsService.RiskManagementTool.HAZID)
     {
      fileName = "HAZID";
     }
     else if(this.RiskExportToolId == ConstantsService.RiskManagementTool.HAZOP)
     {
      fileName = "HAZOP";
     }
     this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
     const apiRequest = {
      Model:
      {
        RiskManagementToolId:riskToolId,
        RiskRequestId:riskRequestId,
        FileName : fileName
      } 
    };
    this.riskService.ExportRiskToExcel(apiRequest, this.callbackMethodForExportRiskToExcel.bind(this));
  }

  callbackMethodForExportRiskToExcel(response) {
    if(response)
    { 
      if(this.RiskExportToolId == ConstantsService.RiskManagementTool.HEMP)
      {
        var fileDownLoadName = "Detailed-HEMP-Report-RSK" + this.RiskExportId + ".xlsx"; //Here we can assign name of the document
        FileUtility.downloadPDF(response, fileDownLoadName);
      }
      else if(this.RiskExportToolId == ConstantsService.RiskManagementTool.JSA)
      {
        var fileDownLoadName = "Detailed-JSA-Report-RSK" + this.RiskExportId + ".xlsx"; //Here we can assign name of the document
        FileUtility.downloadPDF(response, fileDownLoadName);
      }
      else if(this.RiskExportToolId == ConstantsService.RiskManagementTool.HAZID)
      {
        var fileDownLoadName = "HAZID-RSK" + this.RiskExportId + ".xlsx"; //Here we can assign name of the document
        FileUtility.downloadPDF(response, fileDownLoadName);
      }
      else if(this.RiskExportToolId == ConstantsService.RiskManagementTool.HAZOP)
      {
        var fileDownLoadName = "HAZOP-RSK" + this.RiskExportId + ".xlsx"; //Here we can assign name of the document
        FileUtility.downloadPDF(response, fileDownLoadName);
      }

    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
  }

  downloadPDF(riskRequestId) {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    this.riskRequestId = riskRequestId;
    const apiRequest = {
      Model: {
        ProcessName: "Risk",
        SourceId: this.riskRequestId,
      }
    };
    this.riskService.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }
  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_riskRequest" + this.riskRequestId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  clearSearch() {
    this.searchText = '';
    this.searchModified = true;
    if (this.searchText !== this.riskDashboardFilter.SearchText) {
      this.getRiskForDashboard();
      this.riskService.setAllRiskIds([]);
    }
  }
  getAllMasterForRaiseRisk() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CompanyId: this.loggedInUserJSON.Company.CompanyId
      }
    };
    this.riskService.getAllMasterForRaiseRisk(apiRequest, this.callbackMethodGetAllMasterForRaiseRiskSuccess.bind(this));
  }
  callbackMethodGetAllMasterForRaiseRiskSuccess(response) {
    this.baseService.showRootLoader = false;
    this.riskPermission = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    if (!this.riskPermission.RSK_Add && !this.riskPermission.RSK_Add_Unit && !this.riskPermission.RSK_Admin && !this.riskPermission.RSK_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === RiskConstantsService.RiskRequest.RaiseRisk) {
          this.routesFlag.splice(index, 1);
        }
      }
    }
    if (response.Result) {
      this.riskSources = [];
      response.Result.RiskSource.forEach(element => {
        this.riskSources.push({
          'label': element.Source,
          'value': element.RiskSourceId
        });
        this.selectedRiskSources.push(element.RiskSourceId);
      });
      this.getRiskForDashboard();
    }
  }
  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      // this.searchModified = false;
    }
    this.hideSort = false;
  }
  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }
  searchData() {
    this.searchModified = true;
    if (this.searchText !== this.riskDashboardFilter.SearchText) {
      this.getRiskForDashboard();
      this.riskService.setAllRiskIds([]);
    }
  }
  highlightCurrentSelectedRisk(id) {
    var el = document.getElementById(id);
    while (!this.checked && el !== null) {
      this.checked = true;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      let currentColor = document.getElementById(id).style.backgroundColor;
      if (currentColor !== null && currentColor !== 'darkgray') {
        document.getElementById(id).style.backgroundColor = 'darkgray';
      }
      el = null;
    }
  }
  getCurrentDOMElementId(id) {
    this.riskService.setcurrentRiskRequestId(id);
  }
  ngAfterViewChecked() {
    let currentRiskRequestId = this.riskService.getcurrentRiskRequestId();
    if (currentRiskRequestId !== '') {
      this.highlightCurrentSelectedRisk(currentRiskRequestId);
    }
  }
  showContextMenu(risk) {
    this.selectedRisk = risk.RiskRequestId;
  }
  openTask() {
    window.open('/risk/raise-risk/' + this.selectedRisk, '_blank')
    this.contextMenu.hide();
  }
  selectAllRisks(checked) {
   
    this.riskService.setAllRiskIds([]);
    let selectedRisks: StoredRisk[] = [];
    this.riskData.forEach(element => {
      if(element.RiskManagementToolId==this.RiskManagementToolId || this.RiskManagementToolId == 0)
      {
      if (checked) {
        element.Checked = true;
        let riskElem: StoredRisk = new StoredRisk();
        riskElem.RiskRequestId = element.RiskRequestId;
        riskElem.UnitId = element.UnitId;
        selectedRisks = this.riskService.getAllRiskIds();
        if (!selectedRisks) {
          selectedRisks = [];
        }
        selectedRisks.push(riskElem);
        this.riskService.setAllRiskIds(selectedRisks);
      } else {
        element.Checked = false;
        this.riskService.setAllRiskIds([]);
      }
    }
    else {
      element.Checked = false;
      this.riskService.setAllRiskIds([]);
    }
    });
    this.riskDashboardFilter.SelectAll = this.isRisksChecked;
    this.baseService.setFilterData('riskFilter', JSON.stringify(this.riskDashboardFilter));
  }
  selectRisks(risk, event) {
    let risks = this.riskService.getAllRiskIds();
    if (event.target.checked) {
      let riskElem: StoredRisk = new StoredRisk();
      riskElem.RiskRequestId = risk.RiskRequestId;
      riskElem.UnitId = risk.UnitId;
      risks.push(riskElem);
      if (risks.length === this.riskData.length) {
        this.isRisksChecked = true;
      }
    } else {
      this.isRisksChecked = false;
      this.riskDashboardFilter.SelectAll = this.isRisksChecked;
      for (let index = 0; index < risks.length; index++) {
        const element = risks[index];
        if (risk.RiskRequestId === element.RiskRequestId) {
          risks.splice(index, 1);
          break;
        }
      }
    }
   
    this.riskService.setAllRiskIds(risks);
    this.baseService.setFilterData('riskFilter', JSON.stringify(this.riskDashboardFilter));
  }
  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    this.riskSourceIdsDetails = [];
    this.riskService.getAllRiskIds().forEach(element => {
      this.riskSourceIdsDetails.push({
        ProcessName: 'Risk',
        SourceId: element.RiskRequestId,
        UserId: this.loggedInUserJSON.UserId
      });
    });
    if (this.riskSourceIdsDetails.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: this.riskSourceIdsDetails,
        }
      }
      this.observationService.downloadZIP(apiRequest, this.callbackMethodForDownloadZIP.bind(this));
    }
  }
  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_risk.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  xlsMain:any;
  xlsDetail:any;

  exportToExcel(gridData) {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const filter = JSON.parse(this.baseService.getFilterData('riskFilter'));
    filter.SourceIds = [];
    this.riskService.getAllRiskIds().forEach(element => {
      filter.SourceIds.push(element.RiskRequestId);
    });;
    const apiRequest = {
      Model: filter
    };
    // Call dummy method to post data
    this.riskService.ExportToExcelOnRiskDashBoard(apiRequest, this.callbackMethodForexportToExcelRiskData.bind(this));
  }

  callbackMethodForexportToExcelRiskData(response) {
    if(response){
      // const filter = JSON.parse(this.baseService.getFilterData('riskFilter'));
      // this.exportData = response.Result;
      // this.columnList = [
      //   { key: "DisplayId", value: "Risk ID" },
      //   { key: "HazardIdentified", value: "Hazard Identified" },
      //   { key: "Source", value: "Source" },
      //   { key: "CreatedDate", value: "Risk Added Date" },
      //   { key: "UnitName", value: "Unit" },
      //   { key: "Status", value: "Status" },
      //   { key: "RequiredApproval" , value: "Required Approval" },
      //   { key: "ApprovalStatus", value: "Approval Status" },
      //   { key: "ToolName", value: "Tool Name" }
      // ];

      // const parsedResponse = FileUtility.convertToCSVFile(this.exportData, this.columnList,false);
      // FileUtility.downloadCSV(parsedResponse, 'RiskReport.csv');
      
      var fileDownLoadName = "RiskReport.xlsx"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      }
    }
    this.masterscreenService.getUnits(apiRequestUnit, this.callbackMethodForUnitDetails.bind(this));
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      const unitDetails = response.Result;
      this.unitList = [];
      this.selectedUnit = [];
      unitDetails.forEach((unit) => {
        this.unitList.push(
          {
            'label': unit.UnitName,
            'value': unit.UnitId,
            'checked': true
          }
        );
        this.selectedUnit.push(unit.UnitId);
      });
    }
    this.getAllMasterForRaiseRisk();
  }

  getAllMasterForRisk() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CompanyId: this.loggedInUserJSON.Company.CompanyId
      }
    };
    this.riskService.getAllMasterForRaiseRisk(
      apiRequest,
      this.getAllMasterForRaiseRiskSuccess.bind(this)
    );
  }



  getAllMasterForRaiseRiskSuccess(response: { Result: RaiseRiskAllMaster; }) {
    if(response.Result.RiskManagementTool.length > 0)
    {
      for (var i = response.Result.RiskManagementTool.length - 1; i >= 0; i--) 
      {
       if(response.Result.RiskManagementTool[i].ToolName !== ConstantsService.RiskManagementToolName.MOC && response.Result.RiskManagementTool[i].ToolName !==  ConstantsService.RiskManagementToolName.JSA && response.Result.RiskManagementTool[i].ToolName !==  ConstantsService.RiskManagementToolName.HEMP
       && response.Result.RiskManagementTool[i].ToolName !==  ConstantsService.RiskManagementToolName.HAZOP && response.Result.RiskManagementTool[i].ToolName !== ConstantsService.RiskManagementToolName.HAZID)  
       {
        response.Result.RiskManagementTool.splice(i,1);
       }
      }
    }
    this.raiseRiskAllMaster = response.Result;
    this.baseService.showRootLoader = false;
  }

  getRiskDataBySelectedTool(RiskToolId:number) {
    this.RiskManagementToolId = RiskToolId;
    this.riskService.setAllRiskIds([]);
    this.getRiskForDashboard();              
  }
  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }
  isImport:boolean=false;
  isShowErrorDialog:boolean=false;
  ShowButton:boolean=true;
  ImportErrorList : any;
  
  onSelectFile(evt: any)
  {
    this.disableImport=false;
  /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) 
    {
      this.notificationsService.toastNotify(
        "error",
        "Warning Message",
        "Please Select Single Excel File Only."
      );
      this.disableImport=true;
      return;
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => 
    {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      let wsname: string = wb.SheetNames[0];
      let ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.xlsMain = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }  ));

      /* grab first sheet */
      wsname  = wb.SheetNames[1];
      ws= wb.Sheets[wsname];
      this.xlsDetail = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
    };
    reader.readAsBinaryString(target.files[0])

}

ImportBulkExcel()
{
  this.baseService.showRootLoader = true;
   const apiRequest = {
    Model:
    {
      MainSheet: (this.xlsMain),
      DetailsSheet:this.xlsDetail,
      RiskManagementToolId:ConstantsService.RiskManagementTool.HEMP,
      RiskRequestId:0

    } 
  };
  this.isImport=true;
  this.riskService.ImportBulkRiskFromExcel(apiRequest, this.callbackMethodForImportBulkExport.bind(this));
}
bulkUploadErrors: string[]=[];
callbackMethodForImportBulkExport(response) {
  if (response && response.Success == true) {
    this.isShowErrorDialog=false; 
    if(response.Result.length>0){
      if(this.isImport && response.Result.length > 0)
      {
        this.raiseRisks = response.Result;
        try{
          for (let item of this.raiseRisks) {
            if(item.RiskRequest.ErrorList.length > 0){
              this.bulkUploadErrors.concat(item.RiskRequest.ErrorList);
            }
            else{
              if(Array.isArray(item.ActionDetails)){
                for(let element of item.ActionDetails){
                  element.UnitId = item.RiskRequest.UnitId;
                }
              }
              item.RiskRequest.RaisedBy = this.loggedInUserJSON.UserId;
              item.RiskRequest.RiskIdentifiedBy = item.RiskRequest.RiskIdentifiedByEmployee.UserId;
              item.RiskRequest.IsDraft = false;
              item.RiskAssessmentPEARList = [];
              item.PotentialPEARList =[];
              item.ResidualPEARList =[];
              for(let potential of item.RiskRequest.PotentialPEARList) {
                if (potential.RiskPear === "People") {
                  const tempPear = new PeopleRisk();
                  tempPear.PeopleRiskPear = potential.RiskPear;
                  tempPear.PeopleRiskLikelihood = potential.RiskLikelihood;
                  tempPear.PeopleRiskSeverity = potential.RiskSeverity;
                  this.PotentialPeopleRisk = tempPear;
                  this.PotentialPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
                    tempPear.PeopleRiskSeverity,
                    tempPear.PeopleRiskLikelihood
                  );
                  const tempPearD = new PearDetails();
                  tempPearD.RiskPear = this.PotentialPeopleRisk.PeopleRiskPear;
                  tempPearD.RiskSeverity = this.PotentialPeopleRisk.PeopleRiskSeverity;
                  tempPearD.RiskLikelihood = this.PotentialPeopleRisk.PeopleRiskLikelihood;
                  this.PotentialPeopleRisk.PeopleSelected = true;
                  item.PotentialPEARList.push(tempPearD);
                }
                if (potential.RiskPear === "Assets") {
                  const tempPear = new AssetsRisk();
                  tempPear.AssetsRiskPear = potential.RiskPear;
                  tempPear.AssetsRiskLikelihood = potential.RiskLikelihood;
                  tempPear.AssetsRiskSeverity = potential.RiskSeverity;
                  this.PotentialAssetsRisk = tempPear;
                  this.PotentialAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
                    tempPear.AssetsRiskSeverity,
                    tempPear.AssetsRiskLikelihood
                  );
                  this.PotentialAssetsRisk.AssetsSelected = true;
                  const tempAssetsPear = new PearDetails();
                  tempAssetsPear.RiskPear = this.PotentialAssetsRisk.AssetsRiskPear;
                  tempAssetsPear.RiskSeverity = this.PotentialAssetsRisk.AssetsRiskSeverity;
                  tempAssetsPear.RiskLikelihood = this.PotentialAssetsRisk.AssetsRiskLikelihood;
                  item.PotentialPEARList.push(tempAssetsPear);
                }
                if (potential.RiskPear === "Environment") {
                  const tempPear = new EnvironmentRisk();
                  tempPear.EnvironmentRiskPear = potential.RiskPear;
                  tempPear.EnvironmentRiskLikelihood = potential.RiskLikelihood;
                  tempPear.EnvironmentRiskSeverity = potential.RiskSeverity;
                  this.PotentialEnvironmentRisk = tempPear;
                  this.PotentialEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
                    tempPear.EnvironmentRiskSeverity,
                    tempPear.EnvironmentRiskLikelihood
                  );
                  this.PotentialEnvironmentRisk.EnvironmentSelected = true;
      
                  const tempEnvironmentPear = new PearDetails();
                  tempEnvironmentPear.RiskPear = this.PotentialEnvironmentRisk.EnvironmentRiskPear;
                  tempEnvironmentPear.RiskSeverity = this.PotentialEnvironmentRisk.EnvironmentRiskSeverity;
                  tempEnvironmentPear.RiskLikelihood = this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood;
            
                  item.PotentialPEARList.push(tempEnvironmentPear);
                }
                if (potential.RiskPear === "Reputation") {
                  const tempPear = new ReputationRisk();
                  tempPear.ReputationRiskPear = potential.RiskPear;
                  tempPear.ReputationRiskLikelihood = potential.RiskLikelihood;
                  tempPear.ReputationRiskSeverity = potential.RiskSeverity;
                  this.PotentialReputationRisk = tempPear;
                  this.PotentialReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
                    tempPear.ReputationRiskSeverity,
                    tempPear.ReputationRiskLikelihood
                  );
                  this.PotentialReputationRisk.ReputationSelected = true;
                  const tempReputationPear = new PearDetails();
                  tempReputationPear.RiskPear = this.PotentialReputationRisk.ReputationRiskPear;
                  tempReputationPear.RiskSeverity = this.PotentialReputationRisk.ReputationRiskSeverity;
                  tempReputationPear.RiskLikelihood = this.PotentialReputationRisk.ReputationRiskLikelihood;
                  item.PotentialPEARList.push(tempReputationPear);
                }
                if (potential.RiskPear === "NPT") {
                  const tempPear = new NPTRisk();
                  tempPear.NPTRiskPear = potential.RiskPear;
                  tempPear.NPTRiskLikelihood = potential.RiskLikelihood;
                  tempPear.NPTRiskSeverity = potential.RiskSeverity;
                  this.PotentialNPTRisk = tempPear;
                  this.PotentialNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
                    tempPear.NPTRiskSeverity,
                    tempPear.NPTRiskLikelihood
                  );
                  this.PotentialNPTRisk.NPTSelected = true;
                  const tempNPTPear = new PearDetails();
                  tempNPTPear.RiskPear = this.PotentialNPTRisk.NPTRiskPear;
                  tempNPTPear.RiskSeverity = this.PotentialNPTRisk.NPTRiskSeverity;
                  tempNPTPear.RiskLikelihood = this.PotentialNPTRisk.NPTRiskLikelihood;
                  item.PotentialPEARList.push(tempNPTPear);
                }
              };
              //Residual Pear
              for(let residual of item.RiskRequest.ResidualPEARList){
                if (residual.RiskPear === "People") {
                  const tempPear = new PeopleRisk();
                  tempPear.PeopleRiskPear = residual.RiskPear;
                  tempPear.PeopleRiskLikelihood = residual.RiskLikelihood;
                  tempPear.PeopleRiskSeverity = residual.RiskSeverity;
                  this.ResidualPeopleRisk = tempPear;
                  this.ResidualPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
                    tempPear.PeopleRiskSeverity,
                    tempPear.PeopleRiskLikelihood
                  );
                  this.ResidualPeopleRisk.PeopleSelected = true;
                  const residualPear = new PearDetails();
                  residualPear.RiskPear = this.ResidualPeopleRisk.PeopleRiskPear;
                  residualPear.RiskSeverity = this.ResidualPeopleRisk.PeopleRiskSeverity;
                  residualPear.RiskLikelihood = this.ResidualPeopleRisk.PeopleRiskLikelihood;
                  item.ResidualPEARList.push(residualPear);
                }
                if (residual.RiskPear === "Assets") {
                  const tempPear = new AssetsRisk();
                  tempPear.AssetsRiskPear = residual.RiskPear;
                  tempPear.AssetsRiskLikelihood = residual.RiskLikelihood;
                  tempPear.AssetsRiskSeverity = residual.RiskSeverity;
                  this.ResidualAssetsRisk = tempPear;
                  this.ResidualAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
                    tempPear.AssetsRiskSeverity,
                    tempPear.AssetsRiskLikelihood
                  );
                  this.ResidualAssetsRisk.AssetsSelected = true;
                  const residualAssetsPear = new PearDetails();
                  residualAssetsPear.RiskPear = this.ResidualAssetsRisk.AssetsRiskPear;
                  residualAssetsPear.RiskSeverity = this.ResidualAssetsRisk.AssetsRiskSeverity;
                  residualAssetsPear.RiskLikelihood = this.ResidualAssetsRisk.AssetsRiskLikelihood;
                  item.ResidualPEARList.push(residualAssetsPear);
                }
                if (residual.RiskPear === "Environment") {
                  const tempPear = new EnvironmentRisk();
                  tempPear.EnvironmentRiskPear = residual.RiskPear;
                  tempPear.EnvironmentRiskLikelihood = residual.RiskLikelihood;
                  tempPear.EnvironmentRiskSeverity = residual.RiskSeverity;
                  this.ResidualEnvironmentRisk = tempPear;
                  this.ResidualEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
                    tempPear.EnvironmentRiskSeverity,
                    tempPear.EnvironmentRiskLikelihood
                  );
                  this.ResidualEnvironmentRisk.EnvironmentSelected = true;
                  const residualEnvPear = new PearDetails();
                  residualEnvPear.RiskPear = this.ResidualEnvironmentRisk.EnvironmentRiskPear;
                  residualEnvPear.RiskSeverity = this.ResidualEnvironmentRisk.EnvironmentRiskSeverity;
                  residualEnvPear.RiskLikelihood = this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood;
                  item.ResidualPEARList.push(residualEnvPear);
                }
                if (residual.RiskPear === "Reputation") {
                  const tempPear = new ReputationRisk();
                  tempPear.ReputationRiskPear = residual.RiskPear;
                  tempPear.ReputationRiskLikelihood = residual.RiskLikelihood;
                  tempPear.ReputationRiskSeverity = residual.RiskSeverity;
                  this.ResidualReputationRisk = tempPear;
                  this.ResidualReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
                    tempPear.ReputationRiskSeverity,
                    tempPear.ReputationRiskLikelihood
                  );
                  this.ResidualReputationRisk.ReputationSelected = true;
                  const residualReputationPear = new PearDetails();
                  residualReputationPear.RiskPear = this.ResidualReputationRisk.ReputationRiskPear;
                  residualReputationPear.RiskSeverity = this.ResidualReputationRisk.ReputationRiskSeverity;
                  residualReputationPear.RiskLikelihood = this.ResidualReputationRisk.ReputationRiskLikelihood;
                  item.ResidualPEARList.push(residualReputationPear);
                }
                if (residual.RiskPear === "NPT") {
                  const tempPear = new NPTRisk();
                  tempPear.NPTRiskPear = residual.RiskPear;
                  tempPear.NPTRiskLikelihood = residual.RiskLikelihood;
                  tempPear.NPTRiskSeverity = residual.RiskSeverity;
                  this.ResidualNPTRisk = tempPear;
                  this.ResidualNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
                    tempPear.NPTRiskSeverity,
                    tempPear.NPTRiskLikelihood
                  );
                  this.ResidualNPTRisk.NPTSelected = true;
                  const residualNPTPear = new PearDetails();
                  residualNPTPear.RiskPear = this.ResidualNPTRisk.NPTRiskPear;
                  residualNPTPear.RiskSeverity = this.ResidualNPTRisk.NPTRiskSeverity;
                  residualNPTPear.RiskLikelihood = this.ResidualNPTRisk.NPTRiskLikelihood;
                  item.ResidualPEARList.push(residualNPTPear);
                }
              };
              if (this.RiskassessmentPeople) {
                const assessmentPear = new PearDetails();
                assessmentPear.RiskPear = this.RiskassessmentPeople.PeopleRiskPear;
                assessmentPear.RiskSeverity = this.RiskassessmentPeople.PeopleRiskSeverity;
                assessmentPear.RiskLikelihood = this.RiskassessmentPeople.PeopleRiskLikelihood;
                item.RiskAssessmentPEARList.push(assessmentPear);
              }
              if (this.RiskassessmentEnvironment) {
                const assessmentEnvPear = new PearDetails();
                assessmentEnvPear.RiskPear = this.RiskassessmentEnvironment.EnvironmentRiskPear;
                assessmentEnvPear.RiskSeverity = this.RiskassessmentEnvironment.EnvironmentRiskSeverity;
                assessmentEnvPear.RiskLikelihood = this.RiskassessmentEnvironment.EnvironmentRiskLikelihood;
                item.RiskAssessmentPEARList.push(assessmentEnvPear);
              }
              if (this.RiskassessmentAssets) {
                const assessmentAssetsPear = new PearDetails();
                assessmentAssetsPear.RiskPear = this.RiskassessmentAssets.AssetsRiskPear;
                assessmentAssetsPear.RiskSeverity = this.RiskassessmentAssets.AssetsRiskSeverity;
                assessmentAssetsPear.RiskLikelihood = this.RiskassessmentAssets.AssetsRiskLikelihood;
                item.RiskAssessmentPEARList.push(assessmentAssetsPear);
              }
              if (this.RiskassessmentReputation) {
                const assessmentsReputationPear = new PearDetails();
                assessmentsReputationPear.RiskPear = this.RiskassessmentReputation.ReputationRiskPear;
                assessmentsReputationPear.RiskSeverity = this.RiskassessmentReputation.ReputationRiskSeverity;
                assessmentsReputationPear.RiskLikelihood = this.RiskassessmentReputation.ReputationRiskLikelihood;
                item.RiskAssessmentPEARList.push(assessmentsReputationPear);
              }
              if (this.RiskassessmentNPT) {
                const assessmentsNPTPear = new PearDetails();
                assessmentsNPTPear.RiskPear = this.RiskassessmentNPT.NPTRiskPear;
                assessmentsNPTPear.RiskSeverity = this.RiskassessmentNPT.NPTRiskSeverity;
                assessmentsNPTPear.RiskLikelihood = this.RiskassessmentNPT.NPTRiskLikelihood;
                item.RiskAssessmentPEARList.push(assessmentsNPTPear);
              }
            // ResidualMaximum
            this.ResidualPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.ResidualPeopleRisk.PeopleRiskSeverity,
              this.ResidualPeopleRisk.PeopleRiskLikelihood
            );
      
            this.ResidualAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.ResidualAssetsRisk.AssetsRiskSeverity,
              this.ResidualAssetsRisk.AssetsRiskLikelihood
            );
      
            this.ResidualEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.ResidualEnvironmentRisk.EnvironmentRiskSeverity,
              this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood
            );
      
            this.ResidualReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.ResidualReputationRisk.ReputationRiskSeverity,
              this.ResidualReputationRisk.ReputationRiskLikelihood
            );
      
            this.ResidualNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
              this.ResidualNPTRisk.NPTRiskSeverity,
              this.ResidualNPTRisk.NPTRiskLikelihood
            );
      
            this.ResidualP = this.ResidualPeopleRisk.PeopleRiskColor;
            this.ResidualE = this.ResidualEnvironmentRisk.EnvironmentRiskColor;
            this.ResidualA = this.ResidualAssetsRisk.AssetsRiskColor;
            this.ResidualR = this.ResidualReputationRisk.ReputationRiskColor;
            this.ResidualN = this.ResidualNPTRisk.NPTRiskColor;
      
            var ResidualColors = [
              {
                  id: "1",
                  name: "P",
                  color: this.ResidualP
              },
              {
                id: "2",
                name: "E",
                color: this.ResidualE
              },
              {
                  id: "3",
                  name: "A",
                  color: this.ResidualA
              },
              {
                id: "4",
                name: "R",
                color: this.ResidualR
            },
            {
              id: "5",
              name: "N",
              color: this.ResidualN
            }
            ];
      
            let highRisk = ResidualColors.filter(s => s.color == 'riskColorRed').map(s => s.name).toString();
            let mediumRisk = ResidualColors.filter(s => s.color == 'riskColorYellow').map(s => s.name).toString();
            let lowRisk = ResidualColors.filter(s => s.color == 'riskColorBlue').map(s => s.name).toString();
      
            //Check if all risks are of same priority
            if(this.ResidualP  === this.ResidualE && this.ResidualP  === this.ResidualA && this.ResidualP  === this.ResidualR
              && this.ResidualP  === this.ResidualN && (this.ResidualP === "riskColorRed" || this.ResidualP === "riskColorYellow" || this.ResidualP === "riskColorBlue"))
              {
                item.RiskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = "P,E,A,R,N";
              }
              //Check for High risk
              else if(this.ResidualP === "riskColorRed" || this.ResidualE === "riskColorRed" || this.ResidualA === "riskColorRed"
              || this.ResidualR === "riskColorRed" || this.ResidualN === "riskColorRed" )
              {
                item.RiskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = highRisk;
              }
              //Check for Medium risk
              else if(this.ResidualP === "riskColorYellow" || this.ResidualE === "riskColorYellow" || this.ResidualA === "riskColorYellow"
              || this.ResidualR === "riskColorYellow" || this.ResidualN === "riskColorYellow" )
              {
                item.RiskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = mediumRisk;
              }
              //Check for Low risk
              else if(this.ResidualP === "riskColorBlue" || this.ResidualE === "riskColorBlue" || this.ResidualA === "riskColorBlue"
                || this.ResidualR === "riskColorBlue" || this.ResidualN === "riskColorBlue" )
              {
                item.RiskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = lowRisk;
              }
              else
              {
                  item.RiskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = "";
              }
              // CurrentMaximum
              this.RiskassessmentPeople.PeopleRiskColor = this.riskService.getRiskColorClass(
                this.RiskassessmentPeople.PeopleRiskSeverity,
                this.RiskassessmentPeople.PeopleRiskLikelihood
              );
              this.RiskassessmentAssets.AssetsRiskColor = this.riskService.getRiskColorClass(
                this.RiskassessmentAssets.AssetsRiskSeverity,
                this.RiskassessmentAssets.AssetsRiskLikelihood
              );
              this.RiskassessmentEnvironment.EnvironmentRiskColor = this.riskService.getRiskColorClass(
                this.RiskassessmentEnvironment.EnvironmentRiskSeverity,
                this.RiskassessmentEnvironment.EnvironmentRiskLikelihood
              );
              this.RiskassessmentReputation.ReputationRiskColor = this.riskService.getRiskColorClass(
                this.RiskassessmentReputation.ReputationRiskSeverity,
                this.RiskassessmentReputation.ReputationRiskLikelihood
              ); 
              this.RiskassessmentNPT.NPTRiskColor = this.riskService.getRiskColorClass(
                this.RiskassessmentNPT.NPTRiskSeverity,
                this.RiskassessmentNPT.NPTRiskLikelihood
              );
        
              this.CurrentP = this.RiskassessmentPeople.PeopleRiskColor;
              this.CurrentE = this.RiskassessmentEnvironment.EnvironmentRiskColor;
              this.CurrentA = this.RiskassessmentAssets.AssetsRiskColor;
              this.CurrentR = this.RiskassessmentReputation.ReputationRiskColor;
              this.CurrentN = this.RiskassessmentNPT.NPTRiskColor;
        
              var CurrentRiskColors = [
                {
                    id: "1",
                    name: "P",
                    color: this.CurrentP
                },
                {
                  id: "2",
                  name: "E",
                  color: this.CurrentE
                },
                {
                    id: "3",
                    name: "A",
                    color: this.CurrentA
                },
                {
                  id: "4",
                  name: "R",
                  color: this.CurrentR
              },
              {
                id: "5",
                name: "N",
                color: this.CurrentN
            }
            ];
            
               highRisk = CurrentRiskColors.filter(s => s.color == 'riskColorRed').map(s => s.name).toString();
               mediumRisk = CurrentRiskColors.filter(s => s.color == 'riskColorYellow').map(s => s.name).toString();
               lowRisk = CurrentRiskColors.filter(s => s.color == 'riskColorBlue').map(s => s.name).toString();
              
              //Check if all risks are of same priority
              if(this.CurrentP  === this.CurrentE && this.CurrentP  === this.CurrentA && this.CurrentP  === this.CurrentR
                && this.CurrentP  === this.CurrentN && (this.CurrentP === "riskColorRed" || this.CurrentP === "riskColorYellow" || this.CurrentP === "riskColorBlue"))
                {
                  item.RiskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = "P,E,A,R,N";
                }
                //Check for High risk
                else if(this.CurrentP === "riskColorRed" || this.CurrentE === "riskColorRed" || this.CurrentA === "riskColorRed"
                || this.CurrentR === "riskColorRed" || this.CurrentN === "riskColorRed" )
                {
                  item.RiskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = highRisk;
                }
                 //Check for Medium risk
                 else if(this.CurrentP === "riskColorYellow" || this.CurrentE === "riskColorYellow" || this.CurrentA === "riskColorYellow"
                 || this.CurrentR === "riskColorYellow" || this.CurrentN === "riskColorYellow" )
                 {
                  item.RiskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = mediumRisk;
                 }
                 //Check for Low risk
                 else if(this.CurrentP === "riskColorBlue" || this.CurrentE === "riskColorBlue" || this.CurrentA === "riskColorBlue"
                  || this.CurrentR === "riskColorBlue" || this.CurrentN === "riskColorBlue" )
                 {
                  item.RiskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = lowRisk;
                 }
                 else
                 {
                  item.RiskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = "";
                 }
            }
         
          };
          if(this.bulkUploadErrors.length == 0){
            this.raiseBulkRiskHEMP(this.raiseRisks)
          }
          else{
            this.isShowErrorDialog=true;
          }
        }
        catch(err){
          this.baseService.showRootLoader = false;
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Something Went Wrong."
          );
        }
      }

    }
  }
  else{
    this.notificationsService.toastNotify(
      "error",
      "Error Message",
      "Something Went Wrong."
    );
  }
  this.disableExport = false;
}
raiseBulkRiskHEMP(riskBulk) {
  if (riskBulk != undefined) {
    const apiRequest = {
      Model: {
        RiskBulk: riskBulk
      }
    };
    this.riskService.raiseBulkRiskForSelectedTool(apiRequest, this.callbackRaiseBulkRiskSuccess.bind(this));
  }
  else {
    this.baseService.showRootLoader = false;
  }
}
callbackRaiseBulkRiskSuccess(response: { Success: any; Result: number; Errors: null; }) {
  if (response && response.Success) {
    let lstRaiseRisk:RaiseRisk[] = [];
    let lstNotRaiseRisk:RaiseRisk[] = [];
    let totalRiskAdded: number =0;
   if(Array.isArray(response.Result)){
    lstRaiseRisk = response.Result;
    //console.log(lstRaiseRisk);
    lstNotRaiseRisk = lstRaiseRisk.filter(x=> x.RiskRequest.RiskId === 0);
    lstRaiseRisk = lstRaiseRisk.filter(x=> x.RiskRequest.RiskId > 0);
    //console.log(lstNotRaiseRisk);
    totalRiskAdded = lstRaiseRisk.length;
    if(lstNotRaiseRisk.length>0){
    var lstNotRaiseRiskToExcel = lstNotRaiseRisk.map(({RiskRequest})=> {return RiskRequest });
    this.exportAsExcelFile(lstNotRaiseRiskToExcel, "RiskRequestNotAdded");
    }
   }
  this.closePopUp();
    this.notificationsService.toastNotify(
      "success",
      "Success Message",
      totalRiskAdded + " Risk details added successfully"
    );
    this.getRiskForDashboard();
  //  this.savePDF(response.Result);
    // if (this.actionList.length > 0) {
    //   this.updateAction();
    // }
    // if (this.lifeSavingCheckedValueData.length > 0) {
    //   this.submitSpecificationData();
    // }
      // reset form fields
    // this.resetForm();
  }
  if (response.Errors !== null) {
    this.notificationsService.toastNotify(
      "error",
      "Error Message",
      "Something went wrong."
    );
    // this.alertType = ConstantsService.Error;
    // this.errorDetails = response.Errors;
    this.isImport = false;
  }
  this.baseService.showRootLoader = false;
}

 exportAsExcelFile(json: any[], excelFileName: string): void {
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  this.saveAsExcelFile(excelBuffer, excelFileName);
}
 saveAsExcelFile(buffer: any, fileName: string): void {
   const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
   fileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
}
ImportErrorclosePopUp() {
  this.isShowErrorDialog = false;
}
  fileUploadDialog:boolean = false;
  disableImport:boolean = true;
ImportFileClick()
{
  this.fileUploadDialog = true;
}
closePopUp()
{
  this.fileUploadDialog = false;
}
}
export class StoredRisk {
  RiskRequestId: number;
  UnitId: number;
}
